import script from "./xt_horizonalScrollList.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_horizonalScrollList.vue?vue&type=script&setup=true&lang=js"

import "./xt_horizonalScrollList.vue?vue&type=style&index=0&id=5ee6425a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee6425a"]])

export default __exports__